import { api } from '../api';
import { useInfiniteQuery, UseInfiniteQueryResult, useQuery, UseQueryResult } from 'react-query';
import { FYIEntity } from '../types/fyi-docs';
import qs from 'qs';

type GetFYIEntitiesResponse = {
    entities: FYIEntity[];
    total: number;
};

type QueryParams = {
    limit?: number;
    page?: number;
    search?: string;
    type?: ('Company' | 'Partnership' | 'Sole Trader' | 'Trust' | 'Individual')[];
    group?: number[];
    id?: number[];
    showUnmappedEntities?: boolean;
};

async function getFYIEntities(params: QueryParams): Promise<GetFYIEntitiesResponse> {
    const { data } = await api.get('/fyi-docs/entities', {
        params,
        paramsSerializer: (p) => {
            return qs.stringify(p, { arrayFormat: 'repeat' });
        },
    });
    return data;
}

export function useFYIEntities(params: QueryParams = {}, enabled = true): UseQueryResult<FYIEntity[], unknown> {
    return useQuery(['fyi', 'entities', ...Object.values(params)], () => getFYIEntities(params), {
        keepPreviousData: true,
        staleTime: 5000,
        select(data) {
            return data.entities;
        },
        enabled,
    });
}

export function useAllFYIEntities(params: QueryParams = {}, enabled = true): UseInfiniteQueryResult<GetFYIEntitiesResponse, unknown> {
    return useInfiniteQuery(
        ['fyi', 'entities', ...Object.values(params)],
        ({ pageParam = 1 }) => getFYIEntities({ ...params, page: pageParam }),
        {
            keepPreviousData: true,
            cacheTime: 0,
            enabled,
            getNextPageParam: (lastPage, allPages) => {
                if (lastPage.entities.length === 500) {
                    return allPages.length + 1;
                }
                return undefined;
            },
        }
    );
}
